<template>
    <v-container class="mx-5 mt-n2 table-container">
    <item-list :items="entries" :itemsPerPage="itemsPerPage" :headers="headers" :bottomText="$t('changed.perPage')" 
      @search="searchInput" @sortBy="getSortedBy" class="text-left" :searchLabel="$t('searchHistory')" 
      :title="$t('project activity')" @status="statusSelect" :statusEndpoint="'getactivitystatus'">
    <template slot="tfooter" >
      <table-footer :key="footerKey" :requestPeriodically="footerIntervals" :page="page" ref="tfooter" :itemSelected="itemsPerPage" :search="search" :tableInfo="this.$extractions.getActivitiesPagingInfo" @callback="setRequestInterval" :status="status"/>
    </template>
  </item-list>
  </v-container>
</template>
<script>
import FilterMixin from '@/mixins/FilterMixin'
export default {
  mixins: [FilterMixin],
  data(){
    return {
      entries: [],
      sortBy: undefined,
      sortDesc: undefined,
      footerIntervals:false
    }
  },
  components:{
    ItemList: ()=> import('@/components/base/ItemList'),
    TableFooter: ()=>import('@/components/base/TableFooter'),
  },
  async mounted(){
    await this.getData()
      clearInterval(this.historyInterval)
      this.historyInterval = 0
      this.websocket.Subscribe("notification.vms_extractions_web.activity.*", this.getData)
    this.websocket.OnDisconnection(async function(){
      await this.setRequestInterval(this.page, this.itemsPerPage)
    }.bind(this))
    if(!this.websocket.IsConnected()){
      this.websocket.OnOpen(function(){
        clearInterval(this.interval)
        this.interval = 0
      })
      await this.setRequestInterval(this.page, this.itemsPerPage)
    }
  },
  beforeDestroy(){
    clearInterval(this.historyInterval)
    this.historyInterval = undefined
    this.websocket.Unsubscribe("notification.vms_extractions_web.activity.*")
  },
  computed: {
    headers: {
      get(){
        return [
          {
            text:this.$t('name'),
            value: 'project',
            align: 'left',
            width:''
          },
          {
            text:this.$t('changed.to'),
            value: 'statusChange',
            align: 'left',
            width:''
          },
          {
            text:this.$t('changed.by'),
            value: 'changedBy',
            align: 'left',
            width:''
          },
          {
            text:this.$t('changed.date'),
            value: 'timestamp',
            align: 'left',
            width:''
          },
          {
            text:this.$t('additionalInfo'),
            value: 'additionalInfo',
            align: 'left',
            width:''
          }
        ]
      }
    },
    historyInterval: {
      get(){
         return this.$store.getters.getSearchInterval
      },
      set(value){
        return this.$store.commit('setSearchInterval', value)
      }
    },
    updateProjectViewer: {
      get(){
        return this.$store.getters.getUpdateProjectViewer
      },
    },
    websocket: {
      get(){
        return this.$store.getters.getWebsocket
      }
    },
    makeRequest: {
      get(){
        return this.$store.getters.getMakeRequest
      }
    }
  },
  watch:{
    makeRequest: function(newVal, oldVal) {
      if(newVal !== oldVal){
        this.getData()
      }
    }
  },
  methods:{
    async getSortedBy(sortBy, desc){
      this.sortBy = sortBy
      this.sortDesc = desc
      await this.getData()
    },
    async setRequestInterval(page=1, itemsPerPage=10){
      this.page=page
      this.itemsPerPage = itemsPerPage
      if(this.historyInterval!==0)
        clearInterval(this.historyInterval)
      await this.getFullData()
      this.historyInterval = setInterval(this.getData,60000)
    },
    async getFullData(){
      await this.getData()
      this.footerKey ++
    },
    async getData(){
      this.$extractions.getStatusLogs(this.page,this.itemsPerPage,this.sortBy, this.sortDesc,this.search, this.status).then(response=>{
        if(response.data.length===0){
          if( ( (this.search!=="") || (this.status!=="") ) && (this.page===1) ){  
            this.entries = []    
          }
          if(this.page>1){
            this.page --
            this.$refs.tfooter.stepBack(this.page)
          }else{
            this.$refs.tfooter.stepBack(1)
          }
        }
        else{
          this.entries = response.data 
        }
      }).catch(()=>{
        return null
      })
    }
  }  
}
</script>
<style>
  
  .title-activity{
    font-size:18px!important;
    font-family: 'Roboto', 'sans-serif';
    color: #0d5ae5;
  }
  .table-container{
    max-width: 99%!important;
  }
  @media (max-width: 400px) {
    .v-data-table__mobile-row__cell{
      width: 150px!important;
      font-size: 12px;
    }
  }
  @media (max-width: 350px) {
    .v-data-table__mobile-row__cell{
      width: 110px!important;
    }
    .v-data-table__mobile-row__header{
      width: 110px!important;
    }
  }
</style>